import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Box } from 'UIKit';

import { InfoBoxProps } from './ManadatoryDeclarationModal.types';
import styles from './mandatoryDeclarationModal.module.scss';

const InfoBox = ({
  showInfo,
  isRegionNull,
  isOccupationAndIncomeNull,
  isRegionOccupationAndIncomeNull,
}: InfoBoxProps) => {
  const { t } = useTranslation(['account', 'common', 'errors']);
  return (showInfo && (<Box className={styles.infoElobrativeText} data-testid="infoElobrativeText">
    {isRegionNull && <div data-palette="InfoBox">{t('account:whyThisElobrativeStateInfo')}</div>}
    {isOccupationAndIncomeNull && (
      <Box
        data-testid="whyThisElobrativeOcupationAndIncomeInfo"
        className={cn({
          [styles.occupationAndIncomeText]: isRegionOccupationAndIncomeNull,
        })}
      >
        {t('account:whyThisElobrativeOcupationAndIncomeInfo')}
      </Box>
    )}
  </Box>));
};

export default InfoBox;
